export const getAdverts = (state) => state.adverts;
